// ============================================
// ahc-main.js – Apple-Style Animationen
// ============================================

document.addEventListener("DOMContentLoaded", function () {

  // ── 1. Smooth Scroll ──────────────────────
  document.querySelectorAll("a[href^='#']").forEach(function (a) {
    a.addEventListener("click", function (e) {
      var t = document.querySelector(this.getAttribute("href"));
      if (t) {
        e.preventDefault();
        t.scrollIntoView({ behavior: "smooth" });
      }
    });
  });

  // ── 2. FAQ Toggle ─────────────────────────
  document.querySelectorAll(".ahc-faq-q").forEach(function (btn) {
    btn.addEventListener("click", function () {
      this.parentElement.classList.toggle("open");
    });
  });

  // ── 3. Header Scroll Effect ───────────────
  var header = document.querySelector(".ahc-header");
  if (header) {
    window.addEventListener("scroll", function () {
      header.classList.toggle("scrolled", window.scrollY > 50);
    });
  }

  // ── 4. Scroll-Animationen (Apple-Style) ───
  // Alle Elemente die animiert werden sollen
  var animateSelectors = [
    ".ahc-hero-badge",
    ".ahc-hero h1",
    ".ahc-hero-sub",
    ".ahc-hero-actions",
    ".ahc-hero-trust",
    ".ahc-section-label",
    ".ahc-section-title",
    ".ahc-section-sub",
    ".ahc-why-card",
    ".ahc-step",
    ".ahc-single-package",
    ".ahc-faq-item",
    ".ahc-cta-inner",
    ".ahc-sp-left",
    ".ahc-sp-right"
  ];

  var allElements = [];
  animateSelectors.forEach(function (sel) {
    document.querySelectorAll(sel).forEach(function (el) {
      allElements.push(el);
    });
  });

  // Staggered delay für Kacheln (why-cards, steps)
  document.querySelectorAll(".ahc-why-card").forEach(function (el, i) {
    el.style.transitionDelay = (i * 0.1) + "s";
  });
  document.querySelectorAll(".ahc-step").forEach(function (el, i) {
    el.style.transitionDelay = (i * 0.1) + "s";
  });
  document.querySelectorAll(".ahc-faq-item").forEach(function (el, i) {
    el.style.transitionDelay = (i * 0.05) + "s";
  });

  // Initial verstecken
  allElements.forEach(function (el) {
    el.classList.add("ahc-animate");
  });

  // Hero-Elemente sofort animieren
  var heroElements = document.querySelectorAll(
    ".ahc-hero-badge, .ahc-hero h1, .ahc-hero-sub, .ahc-hero-actions, .ahc-hero-trust"
  );
  setTimeout(function () {
    heroElements.forEach(function (el, i) {
      setTimeout(function () {
        el.classList.add("ahc-visible");
      }, i * 150);
    });
  }, 100);

  // IntersectionObserver für den Rest
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add("ahc-visible");
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.12,
    rootMargin: "0px 0px -40px 0px"
  });

  allElements.forEach(function (el) {
    if (!el.closest(".ahc-hero")) {
      observer.observe(el);
    }
  });

  // ── 5. Zähler-Animation im Hero ───────────
  function animateCounter(el, target, suffix) {
    var start = 0;
    var duration = 1800;
    var startTime = null;
    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      // Easing: ease-out
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = Math.floor(eased * target);
      el.textContent = current + suffix;
      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        el.textContent = target + suffix;
      }
    }
    requestAnimationFrame(step);
  }

  // Zähler starten wenn Hero-Trust sichtbar wird
  var trustObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var nums = entry.target.querySelectorAll(".ahc-trust-num");
        nums.forEach(function (num) {
          var text = num.textContent.trim();
          if (text === "100%") animateCounter(num, 100, "%");
          if (text === "2–5") return; // kein Zähler für Ranges
          if (text === "♥") return;
        });
        trustObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.5 });

  var trust = document.querySelector(".ahc-hero-trust");
  if (trust) trustObserver.observe(trust);

  // ── 6. Button Hover Ripple Effect ─────────
  document.querySelectorAll(".ahc-btn-primary, .ahc-btn-nav").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      var ripple = document.createElement("span");
      ripple.classList.add("ahc-ripple");
      var rect = this.getBoundingClientRect();
      ripple.style.left = (e.clientX - rect.left) + "px";
      ripple.style.top = (e.clientY - rect.top) + "px";
      this.appendChild(ripple);
      setTimeout(function () { ripple.remove(); }, 600);
    });
  });

  // ── 7. Parallax im Hero ───────────────────
  var hero = document.querySelector(".ahc-hero");
  if (hero) {
    window.addEventListener("scroll", function () {
      var scrolled = window.scrollY;
      var deco1 = hero.querySelector(".ahc-deco-1");
      var deco2 = hero.querySelector(".ahc-deco-2");
      if (deco1) deco1.style.transform = "translateY(" + (scrolled * 0.15) + "px)";
      if (deco2) deco2.style.transform = "translateY(" + (scrolled * -0.1) + "px)";
    }, { passive: true });
  }

});